import { render, staticRenderFns } from "./SmProxyAnswerEachQuestion.vue?vue&type=template&id=800e004c&"
import script from "./SmProxyAnswerEachQuestion.vue?vue&type=script&lang=ts&"
export * from "./SmProxyAnswerEachQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports